const createObjectFromEntries = arr =>
  Object.assign({}, ...Array.from(arr, ([k, v]) => ({ [k]: v })));

export default createObjectFromEntries;
